<template>
 <component :is="isClient ? 'ClientComponent' : 'SidebarComponent'" />
</template>
<script>

export default {
  components: {
    SidebarComponent: () => import("./SideNavDrl.vue"),
    ClientComponent: () => import("./SideNavClient.vue"),
  },
  data() {
    return {
      isClient: window.location.pathname.includes('client'),
    };
  },
  created() {
   
  },
};
</script>
